export const generateReadableError = (e) => {
  if (!e || !e.response) {
    if (e && e.message === 'Network Error') {
      return 'Network Error';
    }
    return e && e.message ? e.message : 'Network Error';
  }

  const data = e.response.data;
  const readableError =
    (data && data.message) ||
    (data && data.error && data.error.message) ||
    null;

  if (readableError) {
    return readableError;
  }

  if (e.response.status === 401) {
    return 'You are not authorized to perform this action';
  }

  if (e.response.status === 403) {
    return 'You do not have permission to perform this action';
  }

  return 'Server Error';
};
